import React, { FC, useCallback, useEffect, useMemo, useState } from 'react';
import { useHistory, useParams } from 'react-router';
import { toast } from 'react-toastify';

import moment from 'moment';

import DataSource from 'devextreme/data/data_source';
import $createDataSource from 'utils/create-data-souce-instance';
import { isSuccess } from 'utils/responseStatus';

import {
  useChangeComingNomenclatureMainMutation,
  useCreateComingNomenclatureMainMutation,
  useGetComingNomenclatureMainDetailQuery,
  useLazyGetAvailableUnitsQuery,
  useLazyGetComingNomenclatureMainDetailQuery,
} from 'bus/comingNomenclatureMain/services/main';
import { ComingNomenclatureMain } from 'bus/comingNomenclatureMain/types';

import { ComingNomenclatureForm } from '..';

const initialForm: ComingNomenclatureMain = {
  id: null,
  contractorId: null,
  date: moment(new Date()).format('YYYY-MM-DDTHH:mm'),
  nomenclatureAnotation: '',
  nomenclatureId: null,
  factoryId: null,
  objectId: null,
  price: 0,
  tonalSalary: undefined,
  unitId: null,
  comment: '',
  status: 0,
};

const ComingNomenclatureWrapper: FC = () => {
  const history = useHistory();
  let { id } = useParams<{ id: string }>();

  const [createComingNomenclatureMain, { isLoading: isLoadingCreate }] = useCreateComingNomenclatureMainMutation();
  const [changeComingNomenclatureMain, { isLoading: isLoadingChange }] = useChangeComingNomenclatureMainMutation();
  const { data: comingNomenclatureMainDetailData } = useGetComingNomenclatureMainDetailQuery(
    { id },
    { skip: Boolean(!id) },
  );

  const [lazyGetAvailableUnitsQuery] = useLazyGetAvailableUnitsQuery();

  const loading = isLoadingCreate || isLoadingChange;

  const [form, setForm] = useState<ComingNomenclatureMain>(initialForm);

  const [unit, setUnit] = useState<Array<{ id: number; name: string }> | undefined>([]);

  const materialDataSource: DataSource = useMemo(() => {
    return $createDataSource('/v1/Material', 'id');
  }, []);

  const contractorDataStore: DataSource = useMemo(() => {
    const defaultFilter = ['isProvider', '=', true];
    return $createDataSource('/v1/Contractor', 'id', { pageSize: 20, paginate: true, defaultFilter });
  }, []);

  const factoryDataStore: DataSource = useMemo(() => {
    const defaultFilter = ['parentId', '=', null];
    return $createDataSource('/v1/factory', 'id', { pageSize: 20, paginate: true, defaultFilter });
  }, []);

  const handleChangeMaterial = useCallback(
    async (id: number) => {
      await lazyGetAvailableUnitsQuery({ id }).then((data) => {
        if (isSuccess(data)) {
          setUnit(data.data);
        }
      });
    },
    [lazyGetAvailableUnitsQuery],
  );

  useEffect(() => {
    comingNomenclatureMainDetailData && setForm(comingNomenclatureMainDetailData);

    if (comingNomenclatureMainDetailData?.nomenclatureId) {
      handleChangeMaterial(comingNomenclatureMainDetailData?.nomenclatureId);
    }
  }, [comingNomenclatureMainDetailData, handleChangeMaterial]);

  const handleSubmit = async (form: ComingNomenclatureMain) => {
    if (id) {
      await changeComingNomenclatureMain(form)
        .unwrap()
        .then(() => {
          toast.success('Изменения успешно сохранены', {
            position: toast.POSITION.BOTTOM_RIGHT,
          });
        });
    } else {
      const tempFrom = { ...form };
      delete tempFrom.id;
      await createComingNomenclatureMain(form)
        .unwrap()
        .then(() => {
          toast.success('Изменения успешно сохранены', {
            position: toast.POSITION.BOTTOM_RIGHT,
          });
          history.push('/comming-materials');
        });
    }
  };

  return (
    <div className="pt-2">
      <ComingNomenclatureForm
        comingNomenclature={form}
        contractorDataStore={contractorDataStore}
        handleSubmit={handleSubmit}
        materialDataSource={materialDataSource}
        unitDataSource={unit}
        factoryDataStore={factoryDataStore}
        loading={loading}
        onChangeMaterial={handleChangeMaterial}
      />
    </div>
  );
};

export default ComingNomenclatureWrapper;
